import { Typography } from '@/components/atoms'
import { ReactNode } from 'react'
import { StyledOption } from './styles'

export type SelectOptionValueType = string | number | Record<string, unknown>

interface OptionNodeProps {
  value: SelectOptionValueType
  text: string
  icon?: ReactNode | string
  onClick: (value: SelectOptionValueType) => void
  disabled?: boolean
  onIconError?: string
  selected?: boolean
}

export const OptionNode = ({
  value,
  text,
  icon,
  onClick,
  disabled,
  onIconError,
  selected,
}: OptionNodeProps) => (
  <StyledOption
    disabled={disabled}
    onClick={() => {
      if (!disabled) onClick(value)
    }}
    selected={selected}
  >
    {icon && (
      <img
        alt="option icon"
        onError={({ currentTarget }) => {
          currentTarget.onerror = null
          currentTarget.src = onIconError ?? ''
        }}
        src={typeof icon === 'string' ? icon : ''}
      />
    )}
    <Typography variant="captionR">{text}</Typography>
  </StyledOption>
)
